import { TOKEN_ACCESS } from '@/constants/token';
import { clearAuth } from '@/utils/token';
import { queryClient } from '@/configs/react-query';
import axios, {
  type AxiosHeaders,
  type InternalAxiosRequestConfig,
} from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL;

const request = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

request.interceptors.request.use(
  async (
    config: InternalAxiosRequestConfig,
  ): Promise<InternalAxiosRequestConfig> => {
    const token = localStorage.getItem(TOKEN_ACCESS);
    if (token) {
      (config.headers as AxiosHeaders).set('Authorization', `Bearer ${token}`);
    }
    return config;
  },
);
request.interceptors.response.use(
  (response) => response,
  (error: any) => {
    if (error?.response?.status === 401) {
      queryClient.clear();
      clearAuth();
      window.location.href = '/auth';
    }
    if (error?.response?.status === 403) {
      window.history.back();
    }
    return Promise.reject(error);
  },
);

export { request };
